module.exports = __webpack_public_path__ + "static/media/ic-row-add-up.293e89c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-row-add-up.svg
// module id = 823
// module chunks = 17